import {
    ApplicationTypes, DebtTypes,
    EmploymentBases,
    EmploymentTypes,
    MortgageTypes,
    PersonalAccommodationSituations
} from "../../../../models";
import dayjs from "dayjs";
import countries from "../../../../assets/scripts/countries";
import {numberToWords} from "../../string-functions";
import {balanceOfFundsFunds} from "../../../../app/components/client/application-stages/_common/funding/BalanceOfFunds";

export default function (mortgage, config) {
    const ask = [];
    const map = {};
    const errors = [];
    const fill = {}


    // PAGE 1 **********************************************************

    // ASK

    // DONT ASK

    /* Mortgage Type */
    if (mortgage.mortgageType === MortgageTypes.REFINANCE) {
        fill['Switcher'] = {check: true}
    } else if (mortgage.applicationType === ApplicationTypes.FIRSTTIME) {
        fill['First time buyer'] = {check: true}
    } else {
        fill['Second subsequent buyer'] = {check: true}
    }

    /* Title */
    fill['1 Title A1'] = {string: mortgage.applicant1.personal.title}
    /* First Name */
    fill['1 Your first name A1'] = {string: mortgage.applicant1.firstName}
    /* Surname */
    fill['1 Your surname A1'] = {string: mortgage.applicant1.surname}
    /* Gender */
    fill['1 Gender A1'] = {string: mortgage.applicant1.isMale ? 'Male' : 'Female'}
    /* Other Names */
    fill['1 Have you ever been known by any other names? A1'] = {string: mortgage.applicant1.personal.maidenName || 'No'}
    /* Date of Birth */
    fill['1 Your date of birth A1'] = {string: dayjs(mortgage.applicant1.personal.dateOfBirth).format('D MMM YYYY')}
    /* PPS Number */
    fill['1 PPS Number A1'] = {string: mortgage.applicant1.tax.ppsNumber || ''}
    /* Marital Status */
    fill['1 Your marital / civil status A1'] = {string: mortgage.applicant1.personal.maritalStatus}
    /* Current Address */
    fill['1 Your current address A1'] = {string: mortgage.applicant1.personal.addressCurrent}
    /* Current dwelling type */
    fill['1 Current dwelling type A1'] = {
        string: (() => {
            let str = mortgage.applicant1.personal.accommodationSituation
            if (mortgage.requirement.cohabiting) {
                str += ' / LIVING TOGETHER'
            }
            return str
        })()
    }
    /* Time at current address */
    const today = dayjs();
    const app1AddressFromDate = dayjs(mortgage.applicant1.personal.addressCurrentStartDate)
    const years = today.diff(app1AddressFromDate, 'year');
    const months = today.diff(app1AddressFromDate, 'month') - (years * 12);
    fill['1 Time at current address Years A1'] = {string: years.toString()}
    fill['1 Time at current address Months A1'] = {string: months.toString()}

    /* Previous Address if less than 3 years */
    if (years < 3) {
        fill['1 If residing less than 3 years at current address, please provide your previous addresses A1'] = {string: mortgage.applicant1.personal.addressPrevious || ''}
    }

    /*Nationality*/
    fill['1 Your nationality A1'] = {string: countries.find(c => c.alpha_2_code === mortgage.applicant1.personal.nationality).nationality || ''}

    /* Residence in Ireland Length */
    const roi = mortgage.applicant1.personal.irishResidenceStartDate ? dayjs(mortgage.applicant1.personal.irishResidenceStartDate) : null
    if (roi) {
        const yearsA = today.diff(roi, 'year');
        const monthsA = today.diff(roi, 'month') - (yearsA * 12);
        fill['1 How long have you been resident in Ireland? A1'] = {string: `${yearsA} years ${monthsA} months`}
    }

    /* Work visa / permit */
    ask.push({
        label: 'Does App 1 require a visa to work in Ireland? ',
        name: 'app1VisaRequired',
        type: 'CHECK',
        group: 'Application'
    })
    let answer = mortgage.applicant1.personal.nationality
    let country = !!answer ? countries.find(item => item.alpha_2_code === answer) : false
    let visaRequired = !!country && !country.is_EU
    if (visaRequired){
        fill['1 Do you require a visa to work in Ireland? Yes A1'] = {check: true}
    }
    else{
        fill['1 Do you require a visa to work in Ireland? No A1'] = {check: true}
    }


    ask.push({
        label: 'If yes, what visa is required for App 1? ',
        name: 'app1VisaType',
        type: 'TEXT',
        group: 'Application'
    })

    if (visaRequired) {
        if (!config.hasOwnProperty('app1VisaType')) {
            errors.push('Visa type for App 1 not answered');
        } else {
            fill['1 What visa is required? A1'] = {string: config.app1VisaType}
        }
    }

    /* Adult Dependents */
    ask.push({
        label: 'Number of App 1 Adult dependents',
        name: 'app1AdultDependents',
        type: 'TEXT',
        group: 'Application'
    })
    if (config.hasOwnProperty('app1AdultDependents')) {
        fill['1 Adult dependents A1'] = {string: config.app1AdultDependents.toString()}
    }

    /* Child Dependents */
    if (mortgage.applicant1?.personal?.dependentDOBs?.length) {
        fill['1 Child dependents A1'] = {string: mortgage.applicant1.personal.dependentDOBs.length.toString()}
    }

    /* First Time Buyer */
    if (mortgage.applicationType === ApplicationTypes.FIRSTTIME) {
        fill['1 Are you a first time buyer? Yes A1'] = {check: true}
    } else {
        fill['1 Are you a first time buyer? No A1'] = {check: true}
    }

    /* Mobile Phone */
    fill['1 Mobile telephone number A1'] = {string: mortgage.applicant1.mobile || ''}

    /*  Work Phone */
    fill['1 Work telephone number A1'] = {string: mortgage.applicant1.employmentIncome[0].currentEmployerPhone || ''}

    /* Email */
    fill['1 E-mail address A1'] = {string: mortgage.applicant1.email || ''}

    /* Current Lender */
    if (mortgage.mortgageType === MortgageTypes.REFINANCE || mortgage.applicationType === ApplicationTypes.MOVINGHOME || mortgage.applicationType === ApplicationTypes.SECONDTIME) {
        fill['2 If you are an owner occupier please state the full name and address of your current lender A1'] = {string: mortgage.applicant1.properties.find(prop => prop.residingHere).lender || ''}
    }

    /* Rent Amount */
    if (mortgage.applicant1.personal.accommodationSituation === PersonalAccommodationSituations.RENTED || (mortgage.applicant1.personal.accommodationSituation === PersonalAccommodationSituations.RELATIVES && mortgage.applicant1.financial.contributeToRelatives)) {
        fill['2 If you are currently renting, please state your current monthly rent A1'] = {string: mortgage.applicant1.financial.monthlyAccommodationCosts?.toString() || ''}
    }

    if (mortgage.twoApplicants){
        /* Title */
        fill['1 Title A2'] = {string: mortgage.applicant2.personal.title}
        /* First Name */
        fill['1 Your first name A2'] = {string: mortgage.applicant2.firstName}
        /* Surname */
        fill['1 Your surname A2'] = {string: mortgage.applicant2.surname}
        /* Gender */
        fill['1 Gender A2'] = {string: mortgage.applicant2.isMale ? 'Male' : 'Female'}
        /* Other Names */
        fill['1 Have you ever been known by any other names? A2'] = {string: mortgage.applicant2.personal.maidenName || 'No'}
        /* Date of Birth */
        fill['1 Your date of birth A2'] = {string: dayjs(mortgage.applicant2.personal.dateOfBirth).format('D MMM YYYY')}
        /* PPS Number */
        fill['1 PPS Number A2'] = {string: mortgage.applicant2.tax.ppsNumber || ''}
        /* Marital Status */
        fill['1 Your marital / civil status A2'] = {string: mortgage.applicant2.personal.maritalStatus}
        /* Current Address */
        fill['1 Your current address A2'] = {string: mortgage.applicant2.personal.addressCurrent}
        /* Current dwelling type */
        fill['1 Current dwelling type A2'] = {
            string: (() => {
                let str = mortgage.applicant2.personal.accommodationSituation
                if (mortgage.requirement.cohabiting) {
                    str += ' / LIVING TOGETHER'
                }
                return str
            })()
        }
        /* Time at current address */
        const today = dayjs();
        const app2AddressFromDate = dayjs(mortgage.applicant2.personal.addressCurrentStartDate)
        const years2 = today.diff(app2AddressFromDate, 'year');
        const months2 = today.diff(app2AddressFromDate, 'month') - (years2 * 12);
        fill['1 Time at current address Years A2'] = {string: years2.toString()}
        fill['1 Time at current address Months A2'] = {string: months2.toString()}

        /* Previous Address if less than 3 years */
        if (years2 < 3) {
            fill['1 If residing less than 3 years at current address, please provide your previous addresses A2'] = {string: mortgage.applicant2.personal.addressPrevious || ''}
        }

        /*Nationality*/
        fill['1 Your nationality A2'] = {string: countries.find(c => c.alpha_2_code === mortgage.applicant2.personal.nationality).nationality || ''}

        /* Residence in Ireland Length */
        const roi2 = mortgage.applicant2.personal.irishResidenceStartDate ? dayjs(mortgage.applicant2.personal.irishResidenceStartDate) : null
        if (roi2) {
            const yearsA2 = today.diff(roi2, 'year');
            const monthsA2 = today.diff(roi2, 'month') - (yearsA2 * 12);
            fill['1 How long have you been resident in Ireland? A2'] = {string: `${yearsA2} years ${monthsA2} months`}
        }

        /* Work visa / permit */
        let answer2 = mortgage.applicant2.personal.nationality
        let country2 = !!answer2 ? countries.find(item => item.alpha_2_code === answer2) : false
        let visaRequired2 = !!country2 && !country.is_EU
        if (visaRequired2){
            fill['1 Do you require a visa to work in Ireland? Yes A2'] = {check: true}
        }
        else{
            fill['1 Do you require a visa to work in Ireland? No A2'] = {check: true}
        }

        ask.push({
            label: 'If yes, what visa is required for App 2? ',
            name: 'app2VisaType',
            type: 'TEXT',
            group: 'Application'
        })

        if (visaRequired2) {
            if (!config.hasOwnProperty('app2VisaType')) {
                errors.push('Visa type for App 2 not answered');
            } else {
                fill['1 What visa is required? A2'] = {string: config.app2VisaType}
            }
        }

        /* Adult Dependents */
        ask.push({
            label: 'Number of App2 Adult dependents',
            name: 'app2AdultDependents',
            type: 'TEXT',
            group: 'Application'
        })
        if (config.hasOwnProperty('app2AdultDependents')) {
            fill['1 Adult dependents A2'] = {string: config.app2AdultDependents.toString()}
        }

        /* Child Dependents */
        if (mortgage.applicant2?.personal?.dependentDOBs?.length) {
            fill['1 Child dependents A2'] = {string: mortgage.applicant2.personal.dependentDOBs.length.toString()}
        }

        /* First Time Buyer */
        if (mortgage.applicationType === ApplicationTypes.FIRSTTIME) {
            fill['1 Are you a first time buyer? Yes A2'] = {check: true}
        } else {
            fill['1 Are you a first time buyer? No A2'] = {check: true}
        }

        /* Mobile Phone */
        fill['1 Mobile telephone number A2'] = {string: mortgage.applicant2.mobile || ''}

        /*  Work Phone */
        fill['1 Work telephone number A2'] = {string: mortgage.applicant2.employmentIncome[0].currentEmployerPhone || ''}

        /* Email */
        fill['1 E-mail address A2'] = {string: mortgage.applicant2.email || ''}

        /* Current Lender */
        if (mortgage.mortgageType === MortgageTypes.REFINANCE || mortgage.applicationType === ApplicationTypes.MOVINGHOME || mortgage.applicationType === ApplicationTypes.SECONDTIME) {
            fill['2 If you are an owner occupier please state the full name and address of your current lender A2'] = {string: mortgage.applicant2.properties.find(prop => prop.residingHere).lender || ''}
        }

        /* Rent Amount */
        if (mortgage.applicant2.personal.accommodationSituation === PersonalAccommodationSituations.RENTED || (mortgage.applicant2.personal.accommodationSituation === PersonalAccommodationSituations.RELATIVES && mortgage.applicant2.financial.contributeToRelatives)) {
            fill['2 If you are currently renting, please state your current monthly rent A2'] = {string: mortgage.applicant2.financial.monthlyAccommodationCosts?.toString() || ''}
        }
    }

    /* PAYE  Worker */
    const firstPayeJob = mortgage.applicant1.employmentIncome.find(job => job.employmentType === EmploymentTypes.EMPLOYED);
    if (firstPayeJob) {
        fill['3a Your job title A1'] = {string: firstPayeJob.positionHeld || ''}
        fill['3a Start date of employment A1'] = {string: dayjs(firstPayeJob.currentEmployerStartDate).format('D MMM YYYY')}
        fill['3a Employment type A1'] = {string: firstPayeJob.employmentBasis}
        if (firstPayeJob.employmentBasis === EmploymentBases.CONTRACT) {
            ask.push({
                label: 'Remaining Term of Contract for App 1',
                name: 'app1Job1ContractRemainingTerm',
                type: 'TEXT',
                group: 'Application'
            })
            if (config.hasOwnProperty('app1Job1ContractRemainingTerm')) {
                fill['3a If temporary or on contract, length of term remaining A1'] = {string: config.app1Job1ContractRemainingTerm.toString()}
            } else {
                errors.push('Remaining Term of Contract for App 1 not answered');
            }
        }
        fill[`3a Your employer’s name A1`] = {string: firstPayeJob.currentEmployerName || ''}

        ask.push({
            label: 'Nature of App 1 Employers Business?',
            name: 'natureOfApp1EmployerBusiness',
            type: 'TEXT',
            group: 'Application'
        })
        if (config.hasOwnProperty('natureOfApp1EmployerBusiness')) {
            fill[`3a Nature of employer’s business A1`] = {string: config.natureOfApp1EmployerBusiness}
        } else {
            errors.push('Nature of App 1 Employers Business not answered');
        }

        fill[`3a Your employer’s address A1`] = {string: firstPayeJob.currentEmployerAddress || ''}
        fill[`3a Your employer’s telephone number A1`] = {string: firstPayeJob.currentEmployerPhone || ''}

        ask.push({
            label: 'App 1 Probation End Date',
            name: 'app1Job1ProbationaryEndDate',
            type: 'CHECK',
            group: 'Application'
        })
        if (config.hasOwnProperty('app1Job1ProbationaryEndDate')) {
            if (config.app1Job1ProbationaryEndDate) {
                fill['3a If still in probationary period, please confirm date probationary period ends A1'] = {string: config.app1Job1ProbationaryEndDate}
            }
        }

        if (today.diff(dayjs(firstPayeJob.currentEmployerStartDate), 'years', true) < 3) {
            let str = 'Job Title: ' + (firstPayeJob.previousPositionHeld || '') + '\n'
            str += 'Employer Name: ' + (firstPayeJob.previousEmployerName || '') + '\n'
            str += 'Employer Address: ' + (firstPayeJob.previousEmployerAddress || '') + '\n'
            str += 'Start Date: ' + (firstPayeJob.previousEmployerStartDate ? dayjs(firstPayeJob.previousEmployerStartDate).format('D MMM YYYY') : '') + '\n'
            fill['3a Previous employment details (3 year history) A1'] = {string: str}
        }

        /* Income Details for PAYE
        *
        *
        *  non-guaranteed overtime not included
        *  non guaranteed bonus not included
        *  shift allowance not included
        *  other allowance not included
        *
        * */
        const otherIncomesApp1 = mortgage.applicant1.employmentIncome.reduce((acc, job) => {
            job.incomes.forEach(income => {
                if (['shiftAllowance', 'otherAllowance'].includes(income.name)) {
                    acc.push(income.name)
                }
                if (['overtime', 'bonus'].includes(income.name) && !income.guaranteed) {
                    acc.push(income.name + ' NG')
                }
            })
            return acc
        },[])

        const basic = mortgage.applicant1.employmentIncome.reduce((acc, job) => {
            acc += job.grossBasic || 0;
            return acc
        }, 0)
        fill['4 Your basic salary A1'] = {
            string: 'Basic'//basic.toString()
        }
        const gOvertime = mortgage.applicant1.employmentIncome.reduce((acc, job) => {
            acc += job.incomes.find(it => it.name === 'overtime' && it.guaranteed)?.yearMostRecent || 0
            return acc
        }, 0)
        if (gOvertime) {
            fill['4 Your guaranteed overtime A1'] = {
                string: 'G Overtime'//gOvertime.toString()
            }
        }

        const gBonus = mortgage.applicant1.employmentIncome.reduce((acc, job) => {
            acc += job.incomes.find(it => it.name === 'bonus' && it.guaranteed)?.yearMostRecent || 0
            return acc
        }, 0)
        if (gBonus) {
            fill['4 Your guaranteed bonus A1'] = {
                string: 'G Bonus'//gBonus.toString()
            }
        }

        const commission = mortgage.applicant1.employmentIncome.reduce((acc, job) => {
            acc += job.incomes.find(it => it.name === 'commission')?.yearMostRecent || 0
            return acc
        }, 0)
        if (commission) {
            fill['4 Your commission A1'] = {
                string: 'Commission' //commission.toString()
            }
        }

        const carAllowance = mortgage.applicant1.employmentIncome.reduce((acc, job) => {
            acc += job.incomes.find(it => it.name === 'carAllowance')?.yearMostRecent || 0
            return acc
        }, 0)
        if (carAllowance) {
            fill['4 Your car allowance A1'] = {
                string: 'Car Allowance'//carAllowance.toString()
            }
        }

        if (otherIncomesApp1.length) {
            fill['4 Other income A1'] = {
                string: otherIncomesApp1.join(', ')
            }
        }

    }
    const firstSelfJob = mortgage.applicant1.employmentIncome.find(job => job.employmentType === EmploymentTypes.SELFEMPLOYED);
    if (firstSelfJob) {
        fill['3b State your percentage shareholding in the business A1'] = {string: firstSelfJob.percentageOfShares?.toString() || ''};
        fill['3b Your business name and address A1'] = {string: (firstSelfJob.nameOfBusiness || '') + '\n' + (firstSelfJob.businessAddress || '')};
        ask.push({
            label: 'App 1 Business CRO Number',
            name: 'app1Job1BusinessCRONumber',
            type: 'TEXT',
            group: 'Application'
        })
        if (config.hasOwnProperty('app1Job1BusinessCRONumber')) {
            fill['3b CRO Registration Number A1'] = {string: config.app1Job1BusinessCRONumber}
        } else {
            errors.push('App 1 Business CRO Number not answered');
        }
        ask.push({
            label: 'App1 Position Held in Business',
            name: 'app1Job1PositionHeldInBusiness',
            type: 'TEXT',
            group: 'Application'
        })
        if (config.hasOwnProperty('app1Job1PositionHeldInBusiness')) {
            fill['3b Position in the business A1'] = {string: config.app1Job1PositionHeldInBusiness}
        } else {
            errors.push('App1 Position Held in Business not answered');
        }
        ask.push({
            label: 'App1 Business Phone Number',
            name: 'app1Job1BusinessPhoneNumber',
            type: 'TEXT',
            group: 'Application'
        })
        if (config.hasOwnProperty('app1Job1BusinessPhoneNumber')) {
            fill['3b Business telephone number A1'] = {string: config.app1Job1BusinessPhoneNumber}
        } else {
            errors.push('App1 Business Phone Number not answered');
        }

        fill['3b Nature of your business A1'] = {string: firstSelfJob.natureOfBusiness || ''};
        fill['3b Date business established A1'] = {string: firstSelfJob.businessEstablished ? dayjs(firstSelfJob.businessEstablished).format('D MMM YYYY') : ''};


    }

    /* Financial Commitments */
    const names1 = ['6 Type of Outgoing A1 L','6 Lender Name A1 L','6 Purpose of Loan A1 L','6 Terms of Loan A1 L','6 Balance A1 L', '6 Monthly Payment A1 L']
    const app1Loans = mortgage.applicant1.debts.filter(debt => debt.debtType === DebtTypes.LOAN);
    let sumBalance1 = 0;
    let sumMonthly1 = 0;
    app1Loans.forEach((loan,i)=>{
        let index = i + 1;
        fill[`${names1[0]}${index}`] = {string: 'Loan'};
        fill[`${names1[1]}${index}`] = {string: loan.lender || ''};
        fill[`${names1[2]}${index}`] = {string: 'Not Collected'}; //purpose
        fill[`${names1[3]}${index}`] = {string: 'Not Collected'}; //terms
        fill[`${names1[4]}${index}`] = {string: loan.outstanding?.toString() || ''};
        fill[`${names1[5]}${index}`] = {string: loan.monthlyPayment?.toString() || ''};
        sumBalance1 += loan.outstanding || 0;
        sumMonthly1 += loan.monthlyPayment || 0;
    })

    if (app1Loans.length) {
        fill['6 Total Balance A1'] = {string: sumBalance1.toString()};
        fill['6 Total Monthly Payment A1'] = {string: sumMonthly1.toString()};
    }
    const additionalItems1=[]
    if(mortgage.applicant1.financial.paysMaintenance){
        additionalItems1.push({
            type: 'Maintenance',
            amount: mortgage.applicant1.financial.maintenanceCosts || 0,
            frequency: 'Monthly'
        });
    }
    if (mortgage.applicant1.financial.hasChildcareCosts){
        additionalItems1.push({
            type: 'Childcare',
            amount: mortgage.applicant1.financial.monthlyChildcareCosts || 0,
            frequency: 'Monthly'
        });
    }
    additionalItems1.forEach((item,i)=>{
        let index = i + 1;
        fill[`6 Type A1 L${index}`] = {string: item.type};
        fill[`6 Amount A1 L${index}`] = {string: item.amount?.toString() || ''};
        fill[`6 Frequency A1 L${index}`] = {string: item.frequency};
    })
    if (mortgage.twoApplicants){



        const firstPayeJob2 = mortgage.applicant2.employmentIncome.find(job => job.employmentType === EmploymentTypes.EMPLOYED);
        if (firstPayeJob2) {
            fill['3a Your job title A2'] = {string: firstPayeJob2.positionHeld || ''}
            fill['3a Start date of employment A2'] = {string: dayjs(firstPayeJob2.currentEmployerStartDate).format('D MMM YYYY')}
            fill['3a Employment type A2'] = {string: firstPayeJob2.employmentBasis}
            if (firstPayeJob2.employmentBasis === EmploymentBases.CONTRACT) {
                ask.push({
                    label: 'Remaining Term of Contract for App 2',
                    name: 'app2Job1ContractRemainingTerm',
                    type: 'TEXT',
                    group: 'Application'
                })
                if (config.hasOwnProperty('app2Job1ContractRemainingTerm')) {
                    fill['3a If temporary or on contract, length of term remaining A2'] = {string: config.app2Job1ContractRemainingTerm.toString()}
                } else {
                    errors.push('Remaining Term of Contract for App 2 not answered');
                }
            }
            fill[`3a Your employer’s name A2`] = {string: firstPayeJob2.currentEmployerName || ''}

            ask.push({
                label: 'Nature of App 2 Employers Business?',
                name: 'natureOfApp2EmployerBusiness',
                type: 'TEXT',
                group: 'Application'
            })
            if (config.hasOwnProperty('natureOfApp2EmployerBusiness')) {
                fill[`3a Nature of employer’s business A2`] = {string: config.natureOfApp2EmployerBusiness}
            } else {
                errors.push('Nature of App 2 Employers Business not answered');
            }

            fill[`3a Your employer’s address A2`] = {string: firstPayeJob2.currentEmployerAddress || ''}
            fill[`3a Your employer’s telephone number A2`] = {string: firstPayeJob2.currentEmployerPhone || ''}

            ask.push({
                label: 'App 2 Probation End Date',
                name: 'app2Job1ProbationaryEndDate',
                type: 'CHECK',
                group: 'Application'
            })
            if (config.hasOwnProperty('app2Job1ProbationaryEndDate')) {
                if (config.app2Job1ProbationaryEndDate) {
                    fill['3a If still in probationary period, please confirm date probationary period ends A2'] = {string: config.app2Job1ProbationaryEndDate}
                }
            }

            if (today.diff(dayjs(firstPayeJob2.currentEmployerStartDate), 'years', true) < 3) {
                let str2 = 'Job Title: ' + (firstPayeJob2.previousPositionHeld || '') + '\n'
                str2 += 'Employer Name: ' + (firstPayeJob2.previousEmployerName || '') + '\n'
                str2 += 'Employer Address: ' + (firstPayeJob2.previousEmployerAddress || '') + '\n'
                str2 += 'Start Date: ' + (firstPayeJob2.previousEmployerStartDate ? dayjs(firstPayeJob2.previousEmployerStartDate).format('D MMM YYYY') : '') + '\n'
                fill['3a Previous employment details (3 year history) A2'] = {string: str2}
            }

            /* Income Details for PAYE
            *
            *
            *  non-guaranteed overtime not included
            *  non guaranteed bonus not included
            *  shift allowance not included
            *  other allowance not included
            *
            * */
            const otherIncomesApp2 = mortgage.applicant2.employmentIncome.reduce((acc, job) => {
                job.incomes.forEach(income => {
                    if (['shiftAllowance', 'otherAllowance'].includes(income.name)) {
                        acc.push(income.name)
                    }
                    if (['overtime', 'bonus'].includes(income.name) && !income.guaranteed) {
                        acc.push(income.name + ' NG')
                    }
                })
                return acc
            },[])

            const basic2 = mortgage.applicant2.employmentIncome.reduce((acc, job) => {
                acc += job.grossBasic || 0;
                return acc
            }, 0)
            fill['4 Your basic salary A2'] = {
                string: 'Basic'//basic.toString()
            }
            const gOvertime2 = mortgage.applicant2.employmentIncome.reduce((acc, job) => {
                acc += job.incomes.find(it => it.name === 'overtime' && it.guaranteed)?.yearMostRecent || 0
                return acc
            }, 0)
            if (gOvertime2) {
                fill['4 Your guaranteed overtime A2'] = {
                    string: 'G Overtime'//gOvertime.toString()
                }
            }

            const gBonus2 = mortgage.applicant2.employmentIncome.reduce((acc, job) => {
                acc += job.incomes.find(it => it.name === 'bonus' && it.guaranteed)?.yearMostRecent || 0
                return acc
            }, 0)
            if (gBonus2) {
                fill['4 Your guaranteed bonus A2'] = {
                    string: 'G Bonus'//gBonus.toString()
                }
            }

            const commission2 = mortgage.applicant2.employmentIncome.reduce((acc, job) => {
                acc += job.incomes.find(it => it.name === 'commission')?.yearMostRecent || 0
                return acc
            }, 0)
            if (commission2) {
                fill['4 Your commission A2'] = {
                    string: 'Commission' //commission.toString()
                }
            }

            const carAllowance2 = mortgage.applicant2.employmentIncome.reduce((acc, job) => {
                acc += job.incomes.find(it => it.name === 'carAllowance')?.yearMostRecent || 0
                return acc
            }, 0)
            if (carAllowance2) {
                fill['4 Your car allowance A2'] = {
                    string: 'Car Allowance'//carAllowance.toString()
                }
            }

            if (otherIncomesApp2.length) {
                fill['4 Other income A2'] = {
                    string: otherIncomesApp2.join(', ')
                }
            }

        }
        const firstSelfJob2 = mortgage.applicant2.employmentIncome.find(job => job.employmentType === EmploymentTypes.SELFEMPLOYED);
        if (firstSelfJob2) {
            fill['3b State your percentage shareholding in the business A2'] = {string: firstSelfJob2.percentageOfShares?.toString() || ''};
            fill['3b Your business name and address A2'] = {string: (firstSelfJob2.nameOfBusiness || '') + '\n' + (firstSelfJob2.businessAddress || '')};
            ask.push({
                label: 'App 2 Business CRO Number',
                name: 'app2Job1BusinessCRONumber',
                type: 'TEXT',
                group: 'Application'
            })
            if (config.hasOwnProperty('app2Job1BusinessCRONumber')) {
                fill['3b CRO Registration Number A2'] = {string: config.app2Job1BusinessCRONumber}
            } else {
                errors.push('App 2 Business CRO Number not answered');
            }
            ask.push({
                label: 'App2 Position Held in Business',
                name: 'app2Job1PositionHeldInBusiness',
                type: 'TEXT',
                group: 'Application'
            })
            if (config.hasOwnProperty('app2Job1PositionHeldInBusiness')) {
                fill['3b Position in the business A2'] = {string: config.app2Job1PositionHeldInBusiness}
            } else {
                errors.push('App2 Position Held in Business not answered');
            }
            ask.push({
                label: 'App2 Business Phone Number',
                name: 'app2Job1BusinessPhoneNumber',
                type: 'TEXT',
                group: 'Application'
            })
            if (config.hasOwnProperty('app2Job1BusinessPhoneNumber')) {
                fill['3b Business telephone number A2'] = {string: config.app2Job1BusinessPhoneNumber}
            } else {
                errors.push('App2 Business Phone Number not answered');
            }

            fill['3b Nature of your business A2'] = {string: firstSelfJob2.natureOfBusiness || ''};
            fill['3b Date business established A2'] = {string: firstSelfJob2.businessEstablished ? dayjs(firstSelfJob2.businessEstablished).format('D MMM YYYY') : ''};


        }




        //----
        const app2Loans = mortgage.applicant2.debts.filter(debt => debt.debtType === DebtTypes.LOAN);
        const names2 = ['6 Type of Outgoing A2 L','6 Lender Name A2 L','6 Purpose of Loan A2 L','6 Terms of Loan A2 L','6 Balance A2 L', '6 Monthly Payment A2 L']

        let sumBalance2 = 0;
        let sumMonthly2 = 0;
        app2Loans.forEach((loan,i)=>{
            let index = i + 1;
            fill[`${names2[0]}${index}`] = {string: 'Loan'};
            fill[`${names2[1]}${index}`] = {string: loan.lender || ''};
            fill[`${names2[2]}${index}`] = {string: 'Not Collected'}; //purpose
            fill[`${names2[3]}${index}`] = {string: 'Not Collected'}; //terms
            fill[`${names2[4]}${index}`] = {string: loan.outstanding?.toString() || ''};
            fill[`${names2[5]}${index}`] = {string: loan.monthlyPayment?.toString() || ''};
            sumBalance2 += loan.outstanding || 0;
            sumMonthly2 += loan.monthlyPayment || 0;
        })
        if (app2Loans.length) {
            fill['6 Total Balance A2'] = {string: sumBalance2.toString()};
            fill['6 Total Monthly Payment A2'] = {string: sumMonthly2.toString()};
        }
        const additionalItems2=[]
        if(mortgage.applicant2.financial.paysMaintenance){
            additionalItems2.push({
                type: 'Maintenance',
                amount: mortgage.applicant2.financial.maintenanceCosts || 0,
                frequency: 'Monthly'
            });
        }
        if (mortgage.applicant2.financial.hasChildcareCosts){
            additionalItems2.push({
                type: 'Childcare',
                amount: mortgage.applicant2.financial.monthlyChildcareCosts || 0,
                frequency: 'Monthly'
            });
        }
        additionalItems2.forEach((item,i)=>{
            let index = i + 1 + additionalItems1.length;
            fill[`6 Type A2 L${index}`] = {string: item.type};
            fill[`6 Amount A2 L${index}`] = {string: item.amount?.toString() || ''};
            fill[`6 Frequency A2 L${index}`] = {string: item.frequency};
        })
    }

    if (mortgage.applicant1.properties.length){
        const mainProperty1 = mortgage.applicant1.properties[0]
        if (mainProperty1) {
            fill['7 Property address A1'] = {string: mainProperty1.address || ''}
            fill['7 Estimated market value A1'] = {string: mainProperty1.estimatedValue?.toString() || ''}
            fill['7 Debt A1'] = {string: mainProperty1.outstanding?.toString() || ''}
            if (mainProperty1.isRented) {
                let rentPerMonth = mainProperty1.rentPerMonth
                if (!rentPerMonth && mainProperty1.rentPerAnnum) {
                    rentPerMonth = mainProperty1.rentPerAnnum / 12
                }
                fill['7 Rent (monthly) A1'] = {string: rentPerMonth?.toString() || ''}
            }
            if (mainProperty1.isMortgaged) {
                fill['7 Repayment (monthly) A1'] = {string: mainProperty1.monthlyRepayments?.toString() || ''}
                //fill['7 Rate (to 2 decimals) A1'] = {string: ''}
                fill['7 Lender name A1'] = {string: mainProperty1.lender?.toString() || ''}
            }
        }
    }
    if (mortgage.twoApplicants){
        const mainProperty2 = mortgage.applicant2.properties[0]
        if (mainProperty2){
            fill['7 Property address A2'] = {string: mainProperty2.address || ''}
            fill['7 Estimated market value A2'] = {string: mainProperty2.estimatedValue?.toString() || ''}
            fill['7 Debt A2'] = {string: mainProperty2.outstanding?.toString() || ''}
            if (mainProperty2.isRented){
                let rentPerMonth = mainProperty2.rentPerMonth
                if (!rentPerMonth && mainProperty2.rentPerAnnum) {
                    rentPerMonth = mainProperty2.rentPerAnnum /12
                }
                fill['7 Rent (monthly) A2'] = {string: rentPerMonth?.toString() ||''}
            }
            if (mainProperty2.isMortgaged){
                fill['7 Repayment (monthly) A2'] = {string: mainProperty2.monthlyRepayments?.toString() ||''}
                //fill['7 Rate (to 2 decimals) A2'] = {string: ''}
                fill['7 Lender name A2'] = {string: mainProperty2.lender?.toString() ||''}
            }
        }

    }

    /* Credit Information */
    //fill['Check Box14'] arrangement with creditors
    fill['Check Box15'] = {check: true}
    //fill['8 Have you personally or as a company director ever been declared bankrupt, insolvent or made an arrangement with creditors? If yes, when?'] = details

    //fill['Check Box18'] judgement for debt
    fill['Check Box19'] = {check: true}
    //fill['8 Have you ever had a judgement for debt registered against you? If yes, please provide details'] = details

    //fill['Check Box22'] in arrears ever
    fill['Check Box23'] = {check: true}
    //fill['8 Have you ever missed any payment or been in arrears on any mortgage, credit card or other financial commitment? If yes, please provide details'] = details

    //fill['Check Box26'] = refused mortgage
    fill['Check Box27'] = {check: true}
    //fill['8 Have you ever been refused a mortgage on this or any other property or had an application for credit refused? If yes, please provide details'] = details

    //fill['Check Box30'] = property reposseded
    fill['Check Box31'] = {check: true}
    //fill['8 Have you ever had a property repossessed due to arrears or surrender? If yes, please provide details'] = details
    if (mortgage.twoApplicants){

        fill['Check Box17'] = {check: true}
        fill['Check Box21'] = {check: true}
        fill['Check Box25'] = {check: true}
        fill['Check Box29'] = {check: true}
        fill['Check Box33'] = {check: true}
    }


    if (mortgage.needs.policeRecord){
        fill['Check Box34'] = {check: true}
        fill['8 Have you received a formal police caution in the last 5 years, ever been convicted of, or have any prosecutions pending? If yes, please provide details A1'] = mortgage.needs.policeRecordDetails
        if (mortgage.twoApplicants){
            fill['Check Box36'] = {check: true}
            fill['8 Have you received a formal police caution in the last 5 years, ever been convicted of, or have any prosecutions pending? If yes, please provide details A2'] = mortgage.needs.policeRecordDetails
        }
    }
    else{
        fill['Check Box35'] = {check: true}
        if (mortgage.twoApplicants){
            fill['Check Box37'] = {check: true}
        }
    }

    fill['9 Full postal address and Eircode of the property to be mortgaged']= {string: mortgage.property.address || ''}
    fill['9 Purchase price'] = {string: mortgage.property.propertyPrice?.toString() || mortgage.property.propertyValue?.toString() || ''}
    fill['9 Estimated Market Value']= {string: mortgage.property.valuation2Value?.toString() || mortgage.property.valuationValu?.toString() || ''}
    const props = []
    if (mortgage.property.bedrooms){
        props.push(`${numberToWords(mortgage.property.bedrooms)}-bedroom`)
    }
    if (mortgage.property.bathrooms){
        props.push(`${numberToWords(mortgage.property.bathrooms)}-bathroom`)
    }
    let str = props.join(', ')
    fill['9 Description of property'] = {string: str + ' ' + mortgage.property.propertyType?.toLowerCase() || ''}

    let mortgageTermAsDecimal = parseInt(mortgage.activeSubmission.provisionalTerm)
    let mortgageTermAsString = mortgage.activeSubmission.provisionalTerm.toString() + ' years'
    if (mortgage.activeSubmission.provisionalTermPlusMonths){
        mortgageTermAsDecimal += parseInt(mortgage.activeSubmission.provisionalTermPlusMonths) / 12
        mortgageTermAsString += ' and ' + mortgage.activeSubmission.provisionalTermPlusMonths.toString() + ' months'
    }

    console.log({mortgageTermAsDecimal, mortgageTermAsString})

    fill['10 Mortgage term'] = {string: mortgageTermAsString}

    fill['10 Total mortgage amount'] = {string: mortgage.activeSubmission.provisionalLoan?.toString() || mortgage.requirement.loanRequired?.toString() || ''}

    if (mortgage.activeSubmission.provisionalFixedTerm){
        fill['10 Fixed'] = {check: true}
    }
    else{
        fill['10 Variable'] = {check: true}
    }

    const bof = balanceOfFundsFunds(mortgage)
    console.log({bof})

    const otherDescriptions = []
    let descriptionsTotal = 0
    if (bof.gifts){
        fill['10 Deposit from gift'] = {string: bof.gifts?.toString()||''}
    }
    if (bof.helpToBuy){
        fill['10 Deposit from Help-To-Buy'] = {string:bof.helpToBuy?.toString()||''}
        fill['10 Yes'] = {check: true}
        fill['10 Help-To-Buy Application Number'] = {string: mortgage.requirement.helpToBuySchemeApplicationCode?.toString() || ''}
        fill['10 Help-To-Buy Access Code'] = {string: mortgage.requirement.helpToBuySchemeAccessCode?.toString() || '' }
    }
    else{
        fill['10 No'] = {check: true}
    }
    if (bof.requiredSavings){
        fill['10 Deposit from savings'] = {string: bof.requiredSavings?.toFixed(0)}
    }
    if (bof.bookingDepositPaid){
        otherDescriptions.push(`Booking Deposit Paid: €${bof.bookingDepositPaid.toString()}`)
        descriptionsTotal += bof.bookingDepositPaid
    }
    if (bof.contractDepositPaid){
        otherDescriptions.push(`Contract Deposit Paid: €${bof.contractDepositPaid.toString()}`)
        descriptionsTotal += bof.contractDepositPaid
    }
    if (bof.firstHome){
        otherDescriptions.push(`First Home Scheme: €${bof.firstHome.toString()}`)
        descriptionsTotal += bof.firstHome
    }
    if (bof.sellingProperties){
        otherDescriptions.push(`Sale of Property: €${bof.sellingProperties.toString()}`)
        descriptionsTotal += bof.sellingProperties
    }
    if (otherDescriptions.length) {
        fill['10 Please state the source of the deposit you are going to use to purchase the property'] = {string: otherDescriptions.join('\n')}
        fill['10 Deposit from other'] = {string: descriptionsTotal?.toString()||''}
    }
    console.log({bof})

    fill['10 Total deposit'] = {string: ( (bof.totalFunds || 0) - (bof.loan ||0) )?.toFixed(0) || ''}


    fill['12 Name, address and Eircode of solicitor'] = {string: (mortgage.solicitor.firmName ||'') + '\n' + (mortgage.solicitor.firmAddress || '')}
    fill['12 Telephone number'] = {string: mortgage.solicitor.contactPhone?.toString() || ''}

    return {sections: [{ask, fill, map, errors}]};
}